/** Format seconds as m:ss.f for timeline/preview readouts. */
export function formatTime(totalSec: number, withFrames = false): string {
  if (!Number.isFinite(totalSec) || totalSec < 0) totalSec = 0
  const m = Math.floor(totalSec / 60)
  const s = Math.floor(totalSec % 60)
  if (withFrames) {
    // reviewer 差し戻し m3: 2.3s のような値は浮動小数誤差で `2.3 - 2` が
    // 0.29999999999999982 になり、Math.floor(...*30) だと本来フレーム9のところ
    // が8に切り捨てられていた。round + [0,29]クランプ(丸め方向次第で30へ
    // 誤って繰り上がるのを防ぐ)にする。
    const frac = totalSec - Math.floor(totalSec)
    const f = Math.min(29, Math.max(0, Math.round(frac * 30)))
    return `${m}:${String(s).padStart(2, '0')}.${String(f).padStart(2, '0')}`
  }
  return `${m}:${String(s).padStart(2, '0')}`
}

export function clamp(v: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, v))
}

/** One 30fps frame in seconds, for the arrow-key single-frame nudge. */
export const FRAME_SEC = 1 / 30
